export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14321.2468284f.jpg";